import { WithStyles } from '@material-ui/core';
import blueGrey from '@material-ui/core/colors/blueGrey';
import indigo from '@material-ui/core/colors/indigo';
import pink from '@material-ui/core/colors/pink';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Actions from '../actions/testResult';
import TestResultMultiPage, {
	ITestResultMultiPageProps,
} from '../components/TestResultMultiPage';
import TestResultSimple, {
	ITestResultSimpleProps,
} from '../components/TestResultSimple';
import TestResultSingle, {
	ITestResultSingleProps,
} from '../components/TestResultSingle';
import { IRootState } from '../reducers';
import ScenarioFactory, {
	IFetchTestResultParam,
} from '../scenario/TestResultScenarioFactory';

const styles = (theme: Theme) =>
	createStyles({
		group: {
			marginBottom: theme.spacing(2),
			marginTop: theme.spacing(2),
			padding: theme.spacing(3),
		},
		groupTitle: {
			color: theme.palette.text.secondary,
			flexGrow: 1,
			fontSize: '1.2rem',
		},
		hint: {
			borderColor: theme.palette.primary.light,
			borderRadius: '0.2em',
			borderStyle: 'dashed',
			borderWidth: 'thin',
			marginTop: theme.spacing(2),
			overflowWrap: 'break-word',
			padding: theme.spacing(2),
			wordWrap: 'break-word',
		},
		question: {
			borderColor: blueGrey[100],
			borderRadius: '1em',
			borderStyle: 'solid',
			marginTop: theme.spacing(2),
			overflowWrap: 'break-word',
			padding: theme.spacing(2),
			wordWrap: 'break-word',
		},
		questionImage: {
			maxWidth: '100%',
		},
		questionImageContainer: {
			display: 'flex',
			justifyContent: 'center',
		},
		questionTitle: {
			fontSize: '1rem',
			marginBottom: theme.spacing(2),
		},
		resultRight: {
			color: indigo[600],
		},
		resultWrong: {
			color: pink[700],
		},
		root: {
			padding: theme.spacing(2),
			wordBreak: 'break-word',
		},
		table: {
			padding: theme.spacing(1),
		},
		titleFailed: {
			color: pink[700],
		},
		titlePassed: {
			color: indigo[600],
		},
	});

/**
 * テスト結果
 */
class TestResult extends React.Component<IProps> {
	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		this.fetch();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearTestResultParams();
	}

	public render() {
		if (this.props.paperType === 0) {
			// シンプル表示
			const props: ITestResultSimpleProps = {
				classes: this.props.classes,
				groups: this.props.groups,
				paperType: this.props.paperType,
				passFlg: this.props.passFlg,
				questionGroupDisplay: this.props.questionGroupDisplay,
				score: this.props.score,
				scoreMessage: this.props.scoreMessage,
				testTitle: this.props.testTitle,
			};
			return <TestResultSimple {...props} />;
		}

		if (this.props.displayStyle === 0) {
			// 詳細表示 全問一画面
			const props: ITestResultSingleProps = {
				careerID: this.props.careerID,
				classes: this.props.classes,
				groups: this.props.groups,
				lang: this.props.userAttr.lang,
				paperType: this.props.paperType,
				passFlg: this.props.passFlg,
				questionGroupDisplay: this.props.questionGroupDisplay,
				score: this.props.score,
				scoreMessage: this.props.scoreMessage,
				testID: this.props.testID,
				testTitle: this.props.testTitle,
			};
			return <TestResultSingle {...props} />;
		} else {
			// 詳細表示 一問一画面
			const props: ITestResultMultiPageProps = {
				careerID: this.props.careerID,
				classes: this.props.classes,
				groups: this.props.groups,
				lang: this.props.userAttr.lang,
				paperType: this.props.paperType,
				passFlg: this.props.passFlg,
				questionGroupDisplay: this.props.questionGroupDisplay,
				score: this.props.score,
				scoreMessage: this.props.scoreMessage,
				testID: this.props.testID,
				testTitle: this.props.testTitle,
			};
			return <TestResultMultiPage {...props} />;
		}
	}

	/**
	 * テスト結果読み込み
	 */
	protected fetch() {
		// thistoryID はidの2文字目以降
		if (this.props.displayStyle === 0) {
			this.props.fetchTestResultSingle(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				testID: this.props.testID,
				thistoryID: this.props.thistoryID,
				userAttr: this.props.userAttr,
			});
		} else {
			this.props.fetchTestResultMultiPage(this.props.token, {
				careerID: this.props.careerID,
				classID: this.props.classID,
				testID: this.props.testID,
				thistoryID: this.props.thistoryID,
				userAttr: this.props.userAttr,
			});
		}
	}
}

const mapStateToProps = (state: IRootState) => ({
	groups: state.testResult.groups,
	paperType: state.testResult.paperType,
	passFlg: state.testResult.passFlg,
	questionGroupDisplay: state.testResult.questionGroupDisplay,
	score: state.testResult.score,
	scoreMessage: state.testResult.scoreMessage,
	testTitle: state.testResult.testTitle,

	currentTreeItem: state.eLearning.currentTreeItem,

	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	clearTestResultParams: () => dispatch(Actions.clearTestResultParams({})),
	fetchTestResultMultiPage: (token: string, arg: IFetchTestResultParam) => {
		const s = ScenarioFactory.createFetchTestResultMultiPage(
			dispatch,
			token
		);
		s.run(arg);
	},
	fetchTestResultSingle: (token: string, arg: IFetchTestResultParam) => {
		const s = ScenarioFactory.createFetchTestResultSingle(dispatch, token);
		s.run(arg);
	},
});
export interface ITestResultProps {
	careerID: string;
	classID: string;
	testID: string;
	thistoryID: string;
	displayStyle: number;
	questionGroupDisplay: boolean;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & ITestResultProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(TestResult);

const Styled = withStyles(styles)(Connected);

export default Styled;



// WEBPACK FOOTER //
// ./src/containers/TestResult.tsx